module.exports = __webpack_public_path__ + "static/media/loades-eco-park-1-cropped.efa80b3e.png";